import { useState, useEffect, useCallback, forwardRef } from 'react'
import { useFinances } from 'hooks/useFinances'
import { selectData } from 'layouts/onboarding'
import { BalanceSheetRow } from 'layouts/authenticated/pages/dashboard/components/BalanceSheet/BalanceSheetRow'
import { BalanceSheetModalForm } from 'layouts/authenticated/pages/dashboard/components/BalanceSheetModalForm'
import styled from 'styled-components'
import {
  Grid,
  Typography,
  Dialog,
  DialogContent,
  IconButton,
  Grow,
  Box,
} from '@mui/material'
import { Close } from '@mui/icons-material'
import { motion } from 'framer-motion'
const Transition = forwardRef(function Transition(props, ref) {
  return <Grow timeout={300} ref={ref} {...props} />
})
import { BalanceSheetOnPageForm } from 'layouts/authenticated/pages/dashboard/components/BalanceSheetOnPageForm'
import { NewBalanceSheetModalForm } from 'layouts/authenticated/pages/newdash/components/NewBalanceSheetModalForm'
export const TspLoanReview = () => {
  const { deductionTypes } = selectData
  const { getAccounts, createOrUpdateAccount, deleteAccount } = useFinances()
  const [tspLoans, setTspLoans] = useState()
  const [id, setId] = useState()
  const [version, setVersion] = useState()
  const [open, setOpen] = useState(false)
  const [type, setType] = useState('liability')
  const [name, setName] = useState()
  const [subType, setSubType] = useState('tspLoan')
  const [subTypeClassification, setSubTypeClassification] = useState()
  const [sortKey, setSortKey] = useState()
  const [amount, setAmount] = useState()
  const [monthlyPayment, setMonthlyPayment] = useState()
  const [loanEndDate, setLoanEndDate] = useState()
  const [interestRate, setInterestRate] = useState()
  const [modalTitle, setModalTitle] = useState()
  const [canEdit, setCanEdit] = useState(false)

  const storeTspLoans = useCallback(async () => {
    const accounts = await getAccounts()
    setTspLoans((accounts || []).filter(({ subType }) => subType === 'tspLoan'))
  }, [getAccounts])

  useEffect(() => {
    let loaded = false
    if (loaded) return

    storeTspLoans()
    loaded = true
  }, [getAccounts, storeTspLoans])

  const handleClose = useCallback(() => {
    setOpen(false)
    setName('')
    setAmount('')
    setMonthlyPayment('')
    setLoanEndDate('')
    setSortKey('')
    setSubTypeClassification('')
    setInterestRate('')
  }, [])

  const handleSubmit = useCallback(async () => {
    handleClose()
  }, [handleClose])

  const handleOpen = useCallback(() => {
    setModalTitle('Add A TSP Loan')
    setSubType('tspLoan')
    setSubTypeClassification('tspLoan-generalpurpose')
    setOpen(true)
  }, [])

  const handleViewAsset = useCallback(
    ({
      id,
      typeSubTypeUuid,
      _version,
      name,
      amount,
      subType,
      subTypeClassification,
      interestRate,
      loanEndDate,
      monthlyPayment,
    }) => {
      setType('liability')
      setId(id)
      setVersion(_version)
      setSortKey(typeSubTypeUuid)
      setName(name)
      setSubType('tspLoan')
      setAmount(amount)
      setOpen(true)
      setCanEdit(true)
      setModalTitle(`Update ${name}`)
      setSubTypeClassification(subTypeClassification)
      setInterestRate(interestRate)
      setLoanEndDate(loanEndDate)
      setMonthlyPayment(monthlyPayment)
    },
    []
  )

  const handleReload = () => {
    getAccounts()
    handleClose()
  }

  const BalanceSheetToStyle = ({ className }) => {
    return (
      <Grid className={className}>
        <BalanceSheetRow
          accounts={tspLoans}
          handleAddAccount={handleOpen}
          handleViewAccount={handleViewAsset}
          monthlyPayment={monthlyPayment}
          setMonthlyPayment={setMonthlyPayment}
          loanEndDate={loanEndDate}
          setLoanEndDate={setLoanEndDate}
          category={'tspLoan'}
          accountType={'Total TSP Loan Balance'}
          addAccountButtonText={`Add a TSP Loan`}
          isDefaultExpanded
        />
      </Grid>
    )
  }
  const StyledDeductionsTable = styled(BalanceSheetToStyle)`
    .MuiPaper-root > .MuiAccordionSummary-root {
      padding: 0px;
      border-bottom: none;
      border-top: none;
    }
    .MuiPaper-root > .MuiAccordionSummary-root.Mui-expanded {
      background-color: #fff;
      border-top: none;
    }
    .MuiAccordionSummary-root > .MuiAccordionSummary-content {
      margin: 0px;
    }
    .MuiAccordionSummary-root p {
      font-size: 24px !important;
      font-weight: 500;
    }
    .MuiAccordionDetails-root {
      background-color: #fff;
      padding: 0px;
      border-bottom: none;
    }
    .MuiAccordionDetails-root > div {
      border: 1px solid #ddd;
      border-radius: 8px;
    }
    .MuiAccordionDetails-root > div:empty {
      border: none;
    }
    .MuiAccordionDetails-root > div > div:last-of-type {
      border-bottom: none;
    }
    .MuiAccordionDetails-root > button {
      text-transform: capitalize;
      font-size: 16px;
      font-weight: normal;
      border: 1px solid rgb(221, 221, 221);
      border-radius: 8px;
      width: 100%;
      padding: 16px;
    }
  `

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        fullWidth
        maxWidth={'sm'}
        PaperProps={{
          sx: {
            overflow: { xs: 'auto', sm: 'visible' },
            margin: '16px',
            width: 'calc(100% - 32px)',
          },
        }}
      >
        <Box
          sx={{
            justifyContent: 'space-between',
            position: 'relative',
            display: 'flex',
            top: { xs: 8, sm: -48 },
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              top: 0,
              right: { xs: 8, sm: 0 },
              color: '#fff',
              zIndex: 1,
              backgroundColor: '#000',
              '&:hover': {
                backgroundColor: '#000',
              },
            }}
          >
            <Close />
          </IconButton>
        </Box>
        {/* add box to hide the overflow on transition */}
        <Box sx={{ overflow: { xs: 'auto', sm: 'hidden' } }}>
          <DialogContent
            sx={{ overflow: 'visible', paddingTop: { xs: '40px', sm: '16px' } }}
          >
            <motion.div
              key="accounts"
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.3, ease: 'easeInOut' }}
            >
              <Box sx={{ marginBottom: '16px' }}>
                <Typography variant={'headerTitle'} color={'#262627'}>
                  {modalTitle}
                </Typography>
              </Box>
              <NewBalanceSheetModalForm
                handleClose={handleClose}
                canEdit={canEdit}
                type={type}
                name={name}
                amount={amount}
                version={version}
                id={id}
                subType={subType}
                setVersion={setVersion}
                setId={setId}
                setType={setType}
                setSubType={setSubType}
                setSubTypeClassification={setSubTypeClassification}
                subTypeClassification={subTypeClassification}
                interestRate={interestRate}
                setInterestRate={setInterestRate}
                monthlyPayment={monthlyPayment}
                setMonthlyPayment={setMonthlyPayment}
                loanEndDate={loanEndDate}
                setLoanEndDate={setLoanEndDate}
                setName={setName}
                setAmount={setAmount}
                typeSubTypeUuid={sortKey}
                key={sortKey}
                open={true}
                handleSubmit={handleClose}
                reloadAccounts={handleReload}
                newStyle={true}
                // handleClose={onClose}
              />
            </motion.div>
          </DialogContent>
        </Box>
      </Dialog>
      {/* <BalanceSheetModalForm
        handleClose={handleClose}
        name={name}
        amount={amount}
        subType={subType}
        type={type}
        setName={setName}
        setAmount={setAmount}
        typeSubTypeUuid={sortKey}
        open={open}
        handleSubmit={handleSubmit}
        reloadAccounts={storeTspLoans}
        monthlyPayment={monthlyPayment}
        setMonthlyPayment={setMonthlyPayment}
        loanEndDate={loanEndDate}
        setLoanEndDate={setLoanEndDate}
        setSubTypeClassification={setSubTypeClassification}
        subTypeClassification={subTypeClassification}
        interestRate={interestRate}
        setInterestRate={setInterestRate}
        modalHeader={'Edit this TSP Loan'}
      /> */}
      {/* <BalanceSheetOnPageForm
        handleClose={handleClose}
        name={name}
        amount={amount}
        subType={subType}
        type={type}
        setName={setName}
        setAmount={setAmount}
        typeSubTypeUuid={sortKey}
        open={open}
        handleSubmit={handleSubmit}
        reloadAccounts={storeTspLoans}
        monthlyPayment={monthlyPayment}
        setMonthlyPayment={setMonthlyPayment}
        loanEndDate={loanEndDate}
        setLoanEndDate={setLoanEndDate}
        componentHeader={'Tell us about any TSP loan(s) you have'}
      /> */}
      <StyledDeductionsTable />
    </>
  )
}
